import { createSelector } from 'reselect';

const data = (state) => state.activeLocationsMapData;

export const selectFilterData = () => createSelector([data], (state) => state.filter);

export const selectFilterCriteriaData = () =>
  createSelector([data], (state) => state.filterCriteria);
